module.exports = __webpack_public_path__ + "img/icon_quest_code.9ad2f192.png";